import { QueryInterface } from "qpr-base/querybuilder/QueryBuilder";
import { IPeriodLevel } from "./model/model";

type Params = Parameters<QueryInterface["attributes"]>;
type FParams = (
  period: string | undefined,
  allPeriods: IPeriodLevel[]
) => Params;

const workflowAttributes: FParams = (
  period: string | undefined,
  allPeriods: IPeriodLevel[]
) => {
  const items = [
    "name",
    "periodlevel",
    "description",
    "symbol",
    "periodlevelname",
    ["periodname", { period, as: "periodname" }],
    "childobjects",
    ["scorecard.name", { as: "scorecardname" }],
    ["scorecard.symbol", { as: "scorecardsymbol" }],

    ["value", { series: "PERF", as: "PERF", period }],
    ["prettyvalue", { series: "PERF", as: "PERF_prettyvalue", period }],

    ["value", { series: "JS_ATTR", as: "JS_ATTR", period: "latestforseries" }],

    [
      "value",
      { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE", period },
    ],
    [
      "prettyvalue",
      {
        series: "COMPLETION_PERCENTAGE",
        as: "COMPLETION_PERCENTAGE_prettyvalue",
        period,
      },
    ],
    [
      "unit",
      {
        series: "COMPLETION_PERCENTAGE",
        as: "COMPLETION_PERCENTAGE_unit",
        period,
      },
    ],
    [
      "unitname",
      {
        series: "COMPLETION_PERCENTAGE",
        as: "COMPLETION_PERCENTAGE_unitname",
        period,
      },
    ],
    [
      "valuewithoutsymbol",
      {
        series: "COMPLETION_PERCENTAGE",
        as: "COMPLETION_PERCENTAGE_valuewithoutsymbol",
        period,
      },
    ],

    [
      "value",
      { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION", period },
    ],
    [
      "prettyvalue",
      {
        series: "PLANNED_COMPLETION",
        as: "PLANNED_COMPLETION_prettyvalue",
        period,
      },
    ],
    [
      "unit",
      { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_unit", period },
    ],
    [
      "valuewithoutsymbol",
      {
        series: "PLANNED_COMPLETION",
        as: "PLANNED_COMPLETION_valuewithoutsymbol",
        period,
      },
    ],

    ["value", { series: "BUDGET", as: "BUDGET", period }],
    ["prettyvalue", { series: "BUDGET", as: "BUDGET_prettyvalue", period }],
    ["value", { series: "BUDGET_UTIL", as: "BUDGET_UTIL", period }],
    [
      "prettyvalue",
      { series: "BUDGET_UTIL", as: "BUDGET_UTIL_prettyvalue", period },
    ],
    [
      "prettyvalue",
      { series: "EXPENDITURE", as: "EXPENDITURE_prettyvalue", period },
    ],

    ["value", { series: "START_DATE", as: "START_DATE", period }],
    ["value", { series: "END_DATE", as: "END_DATE", period }],
    ["value", { series: "ACTUAL_START_DATE", as: "ACTUAL_START_DATE", period }],
    ["value", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE", period }],
    ["unit", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE_unit", period }],

    [
      "prettyvalue",
      { series: "START_DATE", as: "START_DATE_prettyvalue", period },
    ],
    ["prettyvalue", { series: "END_DATE", as: "END_DATE_prettyvalue", period }],
    [
      "prettyvalue",
      {
        series: "ACTUAL_START_DATE",
        as: "ACTUAL_START_DATE_prettyvalue",
        period,
      },
    ],
    [
      "prettyvalue",
      { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE_prettyvalue", period },
    ],

    ["value", { series: "SLIPPAGE", as: "SLIPPAGE", period }],
    ["prettyvalue", { series: "SLIPPAGE", as: "SLIPPAGE_prettyvalue", period }],
    ["unit", { series: "SLIPPAGE", as: "SLIPPAGE_unit", period }],
    [
      "valuewithoutsymbol",
      { series: "SLIPPAGE", as: "SLIPPAGE_valuewithoutsymbol", period },
    ],

    ["value", { series: "VARIANCE", as: "VARIANCE", period }],
    ["prettyvalue", { series: "VARIANCE", as: "VARIANCE_prettyvalue", period }],
    ["unit", { series: "VARIANCE", as: "VARIANCE_unit", period }],
    [
      "valuewithoutsymbol",
      { series: "VARIANCE", as: "VARIANCE_valuewithoutsymbol", period },
    ],

    ["value", { series: "EXPENDITURE", as: "EXPENDITURE", period }],
    ["unit", { series: "EXPENDITURE", as: "EXPENDITURE_unit", period }],
    ["unitname", { series: "EXPENDITURE", as: "EXPENDITURE_unitname", period }],
    [
      "valuewithoutsymbol",
      { series: "EXPENDITURE", as: "EXPENDITURE_valuewithoutsymbol", period },
    ],
    [
      "prettyvalue",
      { series: "EXPENDITURE", as: "EXPENDITURE_prettyvalue", period },
    ],

    ["value", { series: "PERF_W", as: "PERF_W", period }],
    ["prettyvalue", { series: "PERF_W", as: "PERF_W_prettyvalue", period }],
    ["value", { series: "ACT", as: "ACT", period }],
    ["value", { series: "TAR", as: "TAR", period }],
    ["unit", { series: "ACT", as: "ACT_unit", period }],
    ["unit", { series: "TAR", as: "TAR_unit", period }],
    ["unitname", { series: "ACT", as: "ACT_unitname", period }],
    ["unitname", { series: "TAR", as: "TAR_unitname", period }],
    [
      "valuewithoutsymbol",
      { series: "ACT", as: "ACT_valuewithoutsymbol", period },
    ],
    [
      "valuewithoutsymbol",
      { series: "TAR", as: "TAR_valuewithoutsymbol", period },
    ],
    ["prettyvalue", { series: "ACT", as: "ACT_prettyvalue", period }],
    ["prettyvalue", { series: "TAR", as: "TAR_prettyvalue", period }],
  ];

  for (let i = 0; i < items.length; i += 1) {
    if (Array.isArray(items[i]) && (items[i][1] as any).period) {
      (items[i][1] as any)["resolveui2period"] = "true";
    }
  }

  return items as any;
};

export default workflowAttributes;
